import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=7c912bc9&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"
import style0 from "./Message.vue?vue&type=style&index=0&id=7c912bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c912bc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c912bc9')) {
      api.createRecord('7c912bc9', component.options)
    } else {
      api.reload('7c912bc9', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=7c912bc9&scoped=true&", function () {
      api.rerender('7c912bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Timeline/Message.vue"
export default component.exports